module.exports = __webpack_public_path__ + "static/223585505-204faf148987c7b80c1f25fd8a6ef53a.jpg";